import { z } from "zod";

import { FOETUS_OUTCOME_MAX_LENGTH } from "features/pregnancy/constants/foetusOutcomes";

/**
 * What must be answered to record a foetus as not continuing (KIN-2066).
 *
 * `foetusId` is a string because it comes off a `<select>`; the caller converts it before posting.
 *
 * The outcome is required and capped to match the backend's column, but it is not constrained to
 * any list: there is no code set, and the backend takes whatever is written. Trimmed before
 * measuring, so a field holding only spaces is refused here rather than at the server.
 */
export const endFoetusFormSchema = z.object({
  foetusId: z.string().min(1, "Choose which foetus is no longer continuing"),
  outcome: z
    .string()
    .trim()
    .min(1, "An outcome is required")
    .max(
      FOETUS_OUTCOME_MAX_LENGTH,
      `An outcome must be ${FOETUS_OUTCOME_MAX_LENGTH} characters or fewer`
    ),
});
